<div class="payment-div">
  <h1>{{language.PAYMENT_PROCESSING}}</h1>
  <p>{{language.DO_NOT_CLOSE}}</p>
  <span><img src="../../assets/images/loading.gif" /></span>
</div>
